import { gql } from '@urql/core';
import React from 'react';
import { EditableGameFragment, Espin_Game } from '../../../generated/spin-graphql';
import { ExternalLink } from '../../common/ExternalLink';
import { GameIcon } from '../../icons/GameIcon';
import { DeleteIcon } from '../../svg/DeleteIcon';
import { EditIcon } from '../../svg/EditIcon';

type Props = {
    game: EditableGameFragment;
    editGame?: () => void;
    deleteGame?: () => void;
};

gql`
    fragment EditableGame on espin_player_game {
        id
        game {
            game_definition
            name
        }
        rank
        role
        primary
        tracker
        in_game_username
    }
`;

export const EditableGame: React.FC<Props> = ({ game, editGame, deleteGame }) => {
    const {
        rank,
        role,
        in_game_username,
        tracker,
        primary,
        game: { name, game_definition },
    } = game;
    return (
        <div className="editable-game">
            <div className="header-container">
                <GameIcon game={game_definition} gameName={name} />
                <h2 className="game-name">{name}</h2>
                <div className="controls">
                    {primary && <div className="primary-game">Primary Game</div>}
                    {!!editGame && (
                        <button onClick={editGame} className="edit button circle-button">
                            <EditIcon />
                        </button>
                    )}
                    {!!deleteGame && (
                        <button onClick={deleteGame} className="delete button circle-button">
                            <DeleteIcon />
                        </button>
                    )}
                </div>
            </div>
            <div className="content">
                <div className="rank-role-container">
                    <div className="rank-role-value">
                        <p className="title">Rank</p>
                        <p className="value">{rank}</p>
                    </div>
                    <div className="rank-role-value">
                        <p className="title">Role</p>
                        <p className="value">{role}</p>
                    </div>
                </div>
                {tracker && (
                    <ExternalLink
                        ariaLabel={'Tracker.gg'}
                        className={'tracker button medium-button blue-button'}
                        label={'TRACKER.GG'}
                        link={tracker}
                    />
                )}
            </div>
        </div>
    );
};
